import React, { useContext } from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Global from "../../util/Global";
import { useTranslation } from "react-i18next";
import { AlertContext } from "../../util/Alerter";
import { LoaderComponent } from "../../util/Loader";
import { DashboardHeaderContext } from "../../components/DashboardHeader";
import ProductEditComponent from "../../components/Products/ProductEditComponent";
import NotFound from "../../components/NotFound";



const EditProductList = ({ isAdmin }) => {
  const { id } = useParams();
  const [isLoading, setisLoading] = useState(true)
  const { showAlert } = useContext(AlertContext)
  const [productResponseData, setproductResponseData] = useState()
  const { t } = useTranslation()
  const { setnavLinks, setpageTitle, setpageNavLink, setalertTitle } = useContext(DashboardHeaderContext)


  const PRODUCT_DETAILS_URL = Global.backend + "/index.php/produit/show";


  useEffect(() => {
    if (isAdmin) {
      setnavLinks([{ path: "/dashboard/admin/products", label: "productList" }, { path: "/dashboard/admin/product/" + id, label: "product.details" }])
      setpageNavLink({ path: "/dashboard/admin", label: "adminDashboard" })
    } else {
      setnavLinks([{ path: "/dashboard/user/myproducts", label: "productList" }, { path: "/dashboard/user/myproduct/" + id, label: "product.details" }])
      setpageNavLink({ path: "/dashboard", label: "navigation12.1" })
    }

    setpageTitle("editProduct")
    setalertTitle("")
  }, [])


  useEffect(() => {
    setisLoading(true)

    axios
      .post(PRODUCT_DETAILS_URL, { produitId: id })
      .then((response) => {
        setproductResponseData(response.data)
      }).catch((err) => {
        showAlert("error", t("request.errorFetchProductDetails"))
      })
      .finally(() => {
        setisLoading(false)
      })
  }, [])






  return (
    <LoaderComponent isLoading={isLoading}>
      {!productResponseData ? <NotFound /> : <ProductEditComponent productResponseData={productResponseData} />}
    </LoaderComponent>
  )
};

export default EditProductList;
